<script setup>
import { computed, onMounted, ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

const summarReportsRef = ref(null);
const store = useStore();
const teams = useMapGetter('teams/getTeams');
const { t } = useI18n();

const TECH_SUPPORT_TEAM_NAME = 'тех. поддержка';

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};

const techSupportTeam = computed(() =>
  teams.value.find(
    team => team.name?.trim().toLowerCase() === TECH_SUPPORT_TEAM_NAME
  )
);

const techSupportDownloadLabel = computed(
  () => `${t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')} (${TECH_SUPPORT_TEAM_NAME})`
);

onMounted(() => {
  store.dispatch('teams/get');
});

const onDownloadTechSupportClick = () => {
  if (!techSupportTeam.value?.id) {
    return;
  }

  summarReportsRef.value.downloadReports({
    fileType: 'agent-tech-support',
    teamId: techSupportTeam.value.id,
  });
};
</script>

<template>
  <ReportHeader
    :header-title="$t('AGENT_REPORTS.HEADER')"
    :header-description="$t('AGENT_REPORTS.DESCRIPTION')"
  >
    <div class="flex flex-wrap items-center justify-end gap-2">
      <V4Button
        :label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
        icon="i-ph-download-simple"
        size="sm"
        @click="onDownloadClick"
      />
      <V4Button
        v-if="techSupportTeam"
        :label="techSupportDownloadLabel"
        icon="i-ph-download-simple"
        size="sm"
        slate
        @click="onDownloadTechSupportClick"
      />
    </div>
  </ReportHeader>

  <SummaryReports
    ref="summarReportsRef"
    action-key="summaryReports/fetchAgentSummaryReports"
    getter-key="agents/getAgents"
    fetch-items-key="agents/get"
    summary-key="summaryReports/getAgentSummaryReports"
    type="agent"
  />
</template>
